import axios from 'axios';

export const copyModelWeight = async (modelWeightId) => {
    const response = await axios.post(`/model-weight/${modelWeightId}/copy`);
    return response.data;
};
